import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import VotePage from './components/VotePage';
import AdminScan from './components/AdminScan';
import { setAuthToken } from './api';
import { getCookie, setCookie, eraseCookie } from './cookies';
import { useParams } from 'react-router-dom';

const PublicRedirect = () => {
    const { publicToken } = useParams();
    return <Navigate to={`/vote/${publicToken}`} replace />;
};

function App() {
  const [token, setToken] = useState<string | null>(getCookie('adminToken'));
  // Dark Mode State
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    // Sync token with API instance on load/change
    if (token) {
        setAuthToken(token);
    }
  }, [token]);

  useEffect(() => {
    // Apply Bootstrap theme attribute
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const handleLogin = (newToken: string) => {
    setCookie('adminToken', newToken, 7); // Set cookie for 7 days
    setToken(newToken);
  };

  const handleLogout = () => {
    eraseCookie('adminToken');
    setToken(null);
  };

  return (
    <Router>
      <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', transition: 'background-color 0.3s, color 0.3s' }}>
        {/* Dark Mode Toggle Button (Floating) */}
        <button 
            onClick={toggleTheme}
            className={`btn position-fixed bottom-0 end-0 m-4 rounded-circle shadow-lg d-flex align-items-center justify-content-center ${theme === 'dark' ? 'btn-light' : 'btn-dark'}`}
            style={{ width: '50px', height: '50px', zIndex: 1050 }}
            title={theme === 'dark' ? 'Hellen Modus aktivieren' : 'Dunklen Modus aktivieren'}
        >
            {theme === 'dark' ? '☀️' : '🌙'}
        </button>

        <Routes>
            {/* Admin Routes */}
            <Route path="/admin" element={token ? <Navigate to="/admin/dashboard" /> : <AdminLogin onLogin={handleLogin} />} />
            <Route path="/admin/dashboard" element={token ? <AdminDashboard onLogout={handleLogout} /> : <Navigate to="/admin" />} />
            <Route path="/admin/scan/:token" element={token ? <AdminScan /> : <Navigate to="/admin" />} />
            
            {/* Participant Routes */}
            <Route path="/vote/:token" element={<VotePage />} />
            
            {/* Public Link Route */}
            <Route path="/public/:publicToken" element={<PublicRedirect />} />
            
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/admin" />} />
        </Routes>

        <footer className="mt-auto text-center pb-4 pt-4 text-muted small">
            Powered by <a href="https://SpexHosting.de" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-muted">SpexHosting.de</a>
        </footer>
      </div>
    </Router>
  );
}

export default App;